
<template>
    <transition name="modal" id="contact-info-dialog">
        <div>
            <DxPopup
            height="140px"
            width="calc(100vw - 48px)"
            :hide-on-outside-click="false"
            :show-close-button="true"
            :show-title="false"
            :visible="showPopup"
            :wrapper-attr="dialogAttribute"
            @hidden="$emit('hidden')">

            <template #title>
                <div>
                    update title
                </div>
            </template>

            <template #content>
                <div class="confirm-button-holder">
                    <b-button class="delete-button" @click="updateScouting">Confirm</b-button>
                    <b-button class="cancel-button cursor-pointer" @click="$emit('hidden')">Renunță</b-button>
                </div>
            </template>

            </DxPopup>
        </div>
    </transition>
</template>

<script>

import DxPopup from "devextreme-vue/popup";

export default {
    name: "DeleteDiseaseConfirm",
    props: {
        showPopup: {
            type: Boolean,
            default: false,
        },
    },
    data(){
        return {
            dialogAttribute:{
                class: "payment-delete-confirm-dialog"
            }
        };
    },
    components:{
        DxPopup
    },
    methods:{
        updateScouting(){
            this.$emit("confirmUpdateScouting");
            this.$emit("hidden");
        }
    }
}
</script>
